import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { WsTooltipModule } from "@web/util/ws-ui/ws-tooltip/ws-tooltip.module";
import { TranslateModule } from "@ngx-translate/core";
import { WsUiModule } from "@web/util/ws-ui/ws-ui.module";
import { NotificationPanelComponent } from "./notification-panel.component";

@NgModule({
  declarations: [NotificationPanelComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatDividerModule,
    MatIconModule,
    WsTooltipModule,
    TranslateModule,
    WsUiModule,
  ],
  exports: [NotificationPanelComponent],
})
export class NotificationsModule {}
